import styles from "./back_button.module.css"
import { Link } from "react-router-dom"

export function Back() {
  const to = "/"
  return (
    <div className={styles.root}>
      <Link to={to}>
        <div className={styles.item + " " + styles.icon}>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-12 h-12">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </div>
      </Link>
    </div>
  )
}
